import { VMoney } from "v-money";

// Directivo `v-money` re-exportado como `Money` para registrarlo localmente
// (`directives: { money: Money }`). Vive acá y no en `utils/currency` porque
// `utils/` es código puro sin dependencias de Vue; este es el único acople a
// la librería de directivos. La config de formato (`configMoney`) sigue en
// `utils/currency` por ser data pura.
export const Money = VMoney;
